export default __webpack_public_path__ + "static/banner_t-506bc58a6881e1155e3bb0f081b92fb3.jpg";